import _                                                 from 'underscore';
import React, { FC, useEffect, useState } from 'react';
import classNames                                        from 'classnames';
import { ClassValue }                                    from 'classnames/types';

export interface FadeContainerProps {
	className?: ClassValue,
	fadeMs?: number,
	fadeOut?: boolean,
}

const defaultProps: FadeContainerProps = {
	className: null,
	fadeMs:    null,
	fadeOut:   false,
};

const FadeContainer: FC<FadeContainerProps> = ( props ) => {
	
	let { className, fadeMs, fadeOut, ...containerProps } = props;
	
	let classes = classNames( {
		[ `animation-ms--${ fadeMs }` ]: _.isNumber( fadeMs ),
		[ `fade-in` ]:              !fadeOut,
		[ `fade-out` ]:             fadeOut,
	}, className );
	
	return (
		<div className={ classes } { ...containerProps }>{ props.children }</div>
	);
};

FadeContainer.defaultProps = defaultProps;

export { FadeContainer }
